import React from 'react';
import { Link } from "react-router";
import PropTypes from 'prop-types';
import { database, auth } from '../firebase';
import '../css/Nav.css';
import Report from './Report';
import Menu from './Menu';
import Skeleton from "react-loading-skeleton";
var { version } = require("../project.json");

class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.database = database.ref().child(`users`);
    this.activeItem = props.activeItem;
    this.user = auth.currentUser;
    this.state = {
      user: [],
      ntfs: [],
      open: false,
      open2: false,
      userName: null,
      userImage: "/default_user.jpg", // default user image
      unreadNotifications: 0, // to manage unread notifications display
      isVerified: false, // to manage moderator-specific menus
      isLoading: false
    }

    this.yap = this.yap.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    var bla;
    var blbl;
    const user = this.state.user;
    this.database.on('child_added', snap => {
        user.push({
          id: snap.key,
          userName: snap.val().userName || null,
          userImage: snap.val().userImage,
          verified: snap.val().verified || false, // Checking if the user is a moderator
        });

        user.forEach(u => {
          if (u.id === bla) return;
          else user.splice(user.indexOf(u), 1);
        });

        blbl = user;
        this.setState({
          user: user,
        });
    });

    auth.onAuthStateChanged((user) => {
      if (user === null) {
        this.setState({
          userName: "",
          userImage: "/default_user.jpg",
          unreadNotifications: false,
          isVerified: false, // Reset moderator status if no user is logged in
          isLoading: false
        });
        return;
      }

      bla = user.uid;
      var array = [];
      database.ref("users/" + bla).on('value', snap => {
        array.push(snap.val());
        this.setState({
          userName: array[0]?.moderator === true ? `<a>${array[0].userName}</a>` : array[0].userName,
          userImage: array[0].userImage || "/default_user.jpg",
          isVerified: array[0]?.verified || false, // Set moderator status from database
        });

        this.setState({ isLoading: false });
      });

      database.ref("notifications/" + bla).on('value', snap => {
        var keys = [];
        snap.forEach(function(item) {
          if (item.val().okundu !== true) keys.push(item.val());
        });

        this.setState({ unreadNotifications: keys.length });
      });
    });

    if (this.props.activeItem == "home") document.getElementById("left-1").src = "/item-home-active-light.png";
    else if (this.props.activeItem == "search") document.getElementById("left-2").src = "/search-icon-active-light.png";
    else if (this.props.activeItem == "notification") {
      if (document.getElementById("middle")) document.getElementById("middle").src = "/notification-active-light.png";
      if (document.getElementById("middle2")) document.getElementById("middle2").src = "/notification-active-light.png";
    }
    else if (this.props.activeItem == "profile") document.getElementById("nav-pp2").style.boxShadow = "0 0 0 2px #fff";
  }

  yap() {
    if (this.state.open2 == false) this.setState({open2: true});
    else this.setState({open2: false});
  }

  odak() {
    if (document.getElementById("mother").checked == true) {
      document.getElementById("mother").style.background = null;
      document.getElementById("mother").checked = false;
    } else {
      document.getElementById("mother").style.background = "rgb(245, 112, 41)";
      document.getElementById("mother").checked = true;
    }
  }

  odakClose(e) {
    if (e.target !== document.getElementById("acilirmenu")) {
      document.getElementById("mother").style.background = null;
      document.getElementById("acilirmenu").checked = false;
    }
  }

  render() {
    function SignOut() {
      auth.signOut().then(function() {
        window.location.href = "/giris-yap";
      }).catch(function(error) {console.log(error)});
    }

    document.onclick = (e) => {
      this.odakClose(e);
    }

    return (
      <div>
        <nav className='nav'>
          <ul className="cssMenu">
            <Link to="/"><img src="/favicon.png" className="nav-img"/></Link>
            <a className="nav-title" href="/">TALEFORCE</a>
            <div className="right" id="right">
              <div style={auth.currentUser == null ? {padding: "0"} : {paddingRight: "0px"}}>
                <li><Link to="/">Ana Sayfa</Link></li>
                <li><Link to="/ara">Ara</Link></li>
                <li><Link to="/yazarlar">Yazarlar</Link></li>
                <li style={{display: "none"}} id="dash"><Link to="/dashboard">Kontrol Paneli</Link></li>
              </div>
              {this.state.userName ? (
                <Link to="/profil" id="profile-div">
                  <div className="profile-div">
                    <span id="nav-name" className="nav-name">
                      {this.state.userName === "" ? <Skeleton width={100} style={{ borderRadius: "20px", marginRight: "-2px" }} /> : <span dangerouslySetInnerHTML={{ __html: this.state.userName }} />}
                    </span>
                    <img id="nav-pp" src={this.state.userImage} className="nav-pp" />
                    <div className="nav-pp-effect" id="nav-pp-effect"></div>
                    <div className="right-ntf" id="right-ntf"></div>
                  </div>
                </Link>
              ) : !this.state.isLoading && (
                <div className="ls" id="ls">
                  <Link to="/giris-yap">Giriş Yap</Link> <b>veya</b> <Link to="/kayit-ol">Kaydol</Link>
                </div>
              )}

              {this.state.userName !== "" && (
                <Link to="/bildirimler" id="notfs-div">
                  <div className="notfs-div">
                    <img src="/notification-light.png" id="middle2" />
                    {this.state.unreadNotifications > 0 && <div className="right-ntf-full" id="right-ntf-full">{this.state.unreadNotifications}</div>}
                  </div>
                </Link>
              )}

              <div className="mother">
                <label htmlFor="acilirmenu" className="acilirmenu" id="mother" onClick={this.odak}><img src="/open-menu.png" /></label>
                <input type="checkbox" id="acilirmenu"/>
                <li><ul style={{borderRadius: "0 0 5px 10px"}}>
                  {this.state.isVerified && (
                    <li id="yazi-yab" style={{cursor: "pointer"}}><Link to="/taslaklar">Taslaklar</Link></li>
                  )}
                  <li><Link to="/sss">SSS</Link></li>
                  <li><Link to="/surum-notlari">Sürüm Notları</Link></li>
                  {this.state.userName ? <li id="signout"><a id="signout" className="signout" onClick={SignOut}>Çıkış Yap</a></li> : <></>}
                  <li style={{borderRadius: "0 0 5px 10px", background: "#2f2d33", cursor: "default"}}><a>v.{version}</a></li>
                  <li style={{display: "none"}}><a className="signout">Geri Bildirim</a></li>
                </ul></li>
              </div>
            </div>
          </ul>
        </nav>

        <div className="bottom-menu" id="bottom-menu">
          <div className="tab-item" id="tab-item0"><Link to="/"><img src="/item-home-light.png" className="left-1" id="left-1"/></Link></div>
          <div className="tab-item" id="tab-item1"><Link to="/ara"><img src="/search-icon-light.png" className="left-2" id="left-2"/></Link></div>
          {this.state.userName !== "" && (<div className="tab-item" id="notification-menu">{this.state.unreadNotifications > 0 && <div className="bottom-ntf" id="bottom-ntf"></div>}<Link to="/bildirimler"><img src="/notification-light.png" id="middle"/></Link></div>)}
          {this.state.userName !== "" && (<div className="tab-item" id="profile-menu"><Link to="/profil"><img src={this.state.userImage} className="right-1" id="nav-pp2"/></Link></div>)}
          <div className="tab-item" id="tab-item2"><a onClick={this.yap}><img src="/line-light.png" className="right-2" id="right-2"/></a></div>
        </div>

        <Report opened={this.state.open}/>
        <Menu opened={this.state.open2}/>
      </div>
    )
  }
}

Nav.propTypes = {
  activeItem: PropTypes.string,
}
export default Nav;